import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useStyles } from './PuuidMissing.styles';
import failedImage from 'assets/images/exclamation.svg';

export const PuuidMissing: FC = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.image}>
        <img src={failedImage} alt="failed-image" />
      </Box>
      <Typography className={classes.description}>
        You have to finish the Riot account setup first before linking!{' '}
      </Typography>
      <Typography className={classes.info}>
        TIP: You should play the League of Legends online game from the account at least once.
      </Typography>
    </Box>
  );
};
